














































import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {SolarDataLayer} from "@flashpointbv/solar-datalayer/dist";

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: () => []}) private wishlistItems: Array<object>;
  @Prop({default: true}) readonly showCompare: boolean;

  private wishlistToggle: boolean = this.isOnWishlist;
  private productSwatchesCount: number = this.$mobileDetect.mobile() ? 3 : 4;
  private loadingWishlist: boolean = false;

  private get listTypeClass(): string {
    switch (this.type) {
      case 'home':
      case 'related':
      case 'last-viewed':
      case 'slider':
        return ''
      case 'wishlist':
        return 'small-12 medium-6 cell';
      default:
        return 'small-12 medium-8 cell';
    }
  }

  private get isCompare(): boolean {
    return this.$store.state.CatalogCategoryCompare.productsToCompare.filter(p => p.sku === this.product['sku']).length;
  }

  private set isCompare(compareCheck: boolean) {
    this.$store.dispatch('CatalogCategoryCompare/setProductsToCompare', {
      product: this.product,
      isCompare: compareCheck
    });
  }

  private get getProductGroups(): Array<object> {
    return this.product['product_group'].filter(p => p['sku'] !== this.product['sku']).slice(0,this.productSwatchesCount);
  }

  private addProductClick(): void {
    SolarDataLayer.init().addSelectItem({
      ...this.product,
      'item_id': this.product['product_id'],
      'item_group_id': this.product['pim_productfamilie'] || this.product['product_id'],
      'item_variant': '',
      'item_variant_id': this.product['product_id'],
    }, this.$vnode.key as number, 'Product list');
  }

  private get isOnWishlist(): boolean {
    if (this.type === 'wishlist') {
      return true;
    }

    if (!this.wishlistItems) {
      return false;
    }

    return !!this.wishlistItems.filter(p => p['id'] === this.product['id']).length;
  }

  private async toggleWishlist(): Promise<void> {
    this.loadingWishlist = true;
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.product['product_id']);
      if (this.type !== 'wishlist') {
        await this.$store.dispatch('CustomerWishlist/updateWishlistCount', !this.wishlistToggle);
        this.wishlistToggle = !this.wishlistToggle;
      } else {
        await this.$store.dispatch('CustomerWishlist/updateWishlistCount', false);
        this.$eventBus.$emit('remove-wishlist', this.product['product_id']);
      }
    } catch (e) {
      //
    } finally {
      this.loadingWishlist = false;
    }
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }


  private get locale(): string {
    return this.$config.get('locale');
  }
}
